/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of StoresClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfStoreListResponse,
  SuccessResponse_1OfStoreFranchiseNamesResponse,
  SuccessResponse_1OfIEnumerable_1OfFranchise,
  PostStoresRequest,
  PostStoreRequest,
  UpdateStoreNamesRequest,
  BidfoodWebshopCredentials,
  Store,
  Franchise,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockStores: Store[] = [
  {
    storeNumber: 'VAP001',
    storeName: 'Vapiano Great Portland Street',
    franchiseName: 'Vapiano',
    franchiseId: 10,
    storeGroup: 'London',
  },
  {
    storeNumber: 'VAP002',
    storeName: 'Vapiano Bankside',
    franchiseName: 'Vapiano',
    franchiseId: 10,
    storeGroup: 'London',
  },
  {
    storeNumber: 'VAP003',
    storeName: 'Vapiano Manchester',
    franchiseName: 'Vapiano',
    franchiseId: 10,
    storeGroup: 'North',
  },
  {
    storeNumber: 'FG001',
    storeName: 'Five Guys Covent Garden',
    franchiseName: 'Five Guys',
    franchiseId: 11,
    storeGroup: 'London',
  },
  {
    storeNumber: 'FG002',
    storeName: 'Five Guys Leicester Square',
    franchiseName: 'Five Guys',
    franchiseId: 11,
    storeGroup: 'London',
  },
  {
    storeNumber: 'FG003',
    storeName: 'Five Guys Birmingham',
    franchiseName: 'Five Guys',
    franchiseId: 11,
    storeGroup: 'Midlands',
  },
];

const mockFranchises: Franchise[] = [
  { franchiseId: 10, franchiseName: 'Vapiano', active: true, currentBrandingId: 1, systems: [] },
  { franchiseId: 11, franchiseName: 'Five Guys', active: true, currentBrandingId: 2, systems: [] },
];

/* ---- Mocked Client Implementation ---- */

import { IStoresClient } from '../../interfaces';
export class StoresClientMocked implements IStoresClient {
  constructor(baseUrl?: string) {}

  async storesGET(cancelToken?: CancelToken): Promise<SuccessResponse_1OfStoreListResponse> {
    await delay();
    return successResponse({ stores: mockStores }) as SuccessResponse_1OfStoreListResponse;
  }

  async storesPOST(body?: PostStoresRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body?.stores) {
      body.stores.forEach((store) => {
        mockStores.push({
          storeNumber: store.storeNumber || `STORE00${mockStores.length + 1}`,
          storeName: store.storeName || 'New Store',
          franchiseName: store.franchiseName || 'Demo',
          franchiseId: 1,
          storeGroup: store.storeGroup || '',
        });
      });
    }
  }

  async franchisename(franchiseName?: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfStoreListResponse> {
    await delay();
    const stores = franchiseName
      ? mockStores.filter((s) => s.franchiseName === franchiseName)
      : mockStores;
    return successResponse({ stores }) as SuccessResponse_1OfStoreListResponse;
  }

  async refresh(cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  async enable(body?: PostStoreRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  async franchisenames(cancelToken?: CancelToken): Promise<SuccessResponse_1OfStoreFranchiseNamesResponse> {
    await delay();
    return successResponse({
      franchiseNames: ['Demo', 'Test Franchise'],
    }) as SuccessResponse_1OfStoreFranchiseNamesResponse;
  }

  async franchises(cancelToken?: CancelToken): Promise<SuccessResponse_1OfIEnumerable_1OfFranchise> {
    await delay();
    return successResponse(mockFranchises) as SuccessResponse_1OfIEnumerable_1OfFranchise;
  }

  async storenames(body?: UpdateStoreNamesRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body?.stores) {
      body.stores.forEach((update) => {
        const store = mockStores.find((s) => s.storeNumber === update.storeNumber);
        if (store && update.storeName) {
          store.storeName = update.storeName;
        }
      });
    }
  }

  async bidfoodWebshopCredentials(storeNumber?: string, cancelToken?: CancelToken): Promise<BidfoodWebshopCredentials> {
    await delay();
    return {
      username: 'demo_user',
      password: 'demo_password',
    } as BidfoodWebshopCredentials;
  }

  // ====== Auto-generated stub methods ======


}
